enum PixagriScopes {

    /**
     * Common models/functions shared by several scopes
     *
     */
    CORE = "core",

    /**
     * Authentication
     */
    AUTHENTICATION = "authentication",

    DISTRIBUTORS = "distributors",

    PRODUCERS = "producers",

    PROCESSINGS = "processings",

    INDICATORS = "indicators",

    ORGANIZATIONS = "organizations",

    CONTRACTS = "contracts",

    CUSTOMERS = "customers",

    FIELDS = "fields",

    STATISTICS = "statistics",

    CAMPAIGN = "campaign",

    USERACCESSES = "userAccesses",

    NOTES = "notes",

    REPORT = "report",

    REPORT_JOB = "report_job",

    REPORT_WORKER = "report-worker",

    NOTIFICATION = "notifications",
    PROCESSINGS_ENGINES = "processings-engines",
    USERS = "users",
    CROPS = "crops",
    SOILS = "soils",
    FARMERS = "farmers",
    FARMS = "farms",
    DESCRIPTIONS = "descriptions",
    SUBSCRIPTIONS = "subscriptions",
    COMMERCIAL_PACKAGES = "commercial_packages",
    ORGANISATIONS = "organisations",
    TESTS = "tests",
    MONITORING = "monitoring",
}

export default PixagriScopes;